import classNames from 'classnames';
import React from 'react';
import Box, { BoxProps } from 'ui-box';

export const PageContainer = (props: BoxProps<any>) => {
  return (
    <Box
      {...props}
      className="p-4 pr-0 pb-16 md:p-8 md:pr-0 md:pb-32 lg:p-12 lg:pr-0 lg:pb-64"
    />
  );
};

export const Container = (props: BoxProps<any>) => (
  <Box
    {...props}
    className={classNames(props.className, 'container pr-4 md:pr-8 lg:pr-12')}
  />
);

export const Grid = (props: BoxProps<any>) => (
  <Box
    {...props}
    className={classNames(props.className, 'grid gap-x-4 grid-cols-12')}
  />
);
